module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC6#_idTOCAnchor-2"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC7#_idTOCAnchor-3"
    }
  }, [_vm._v("Invitation: Becoming the Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC8#_idTOCAnchor-4"
    }
  }, [_vm._v("1. Paul and the Mission of God")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC9#_idTOCAnchor-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Reading Paul Missionally")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC10#_idTOCAnchor-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Becoming the Gospel of Faith(fulness), "), _c('br'), _vm._v("Love, and Hope: 1 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC11#_idTOCAnchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Becoming and Telling the Story of Christ: Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC12#_idTOCAnchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Becoming the Gospel of Peace (I): Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC13#_idTOCAnchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Becoming the Gospel of Peace (II): Ephesians")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC14#_idTOCAnchor-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Becoming the Justice of God: 1 & 2 Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC15#_idTOCAnchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Becoming the Gospel of God’s Justice/Righteousness and Glory: Missional Theosis in Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC16#_idTOCAnchor-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Reflections: Becoming the Gospel (Reprise)")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC17#_idTOCAnchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC18#_idTOCAnchor-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index of Subjects and Names")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Gorman_Becoming_the_Gospel_text_CC19#_idTOCAnchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index of Scripture and Other Ancient Sources")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432eaf5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gorman_Becoming_the_Gospel_text_CC5.vue
// module id = 66
// module chunks = 0